import { Icon } from '@eventr/common-storybook'
import { useParams } from 'react-router-dom'
import { useEditSectionContext } from '../../feat/editItinerary/editSectionProvider'

interface IEditButton {
    data: any
    renderOptions: any
}

export const EditArrowIcon = ({ data, renderOptions }: IEditButton) => {
    const { section } = useEditSectionContext()

    const { idItem } = useParams<{
        idItem: string
    }>()
    const path = () => {
        if (renderOptions.pageId) {
            return (
                '/edit/Section/' +
                section?.id +
                '/' +
                idItem +
                '/' +
                renderOptions.pageId +
                '/' +
                data._id
            )
        } else {
            return '/edit/Section/' + section?.id + '/' + data._id
        }
    }
    return (
        // <MainButton
        //     icon="Edit"
        //     text={f(m.General.Edit)}
        //     size="small"
        //     onClick={() => {
        //         hist.push(path())
        //     }}
        // />
        <Icon
            name="Chevron_Right"
            onClick={() => {
                window.pushPath(path())
            }}
        />
    )
}
